import { DataGrid } from '@mui/x-data-grid'
import { FC } from 'react'
import { HomeI } from '../../../models/home'
import { ProductosI } from '../../../models/productos'
import Catalogo from '../../Catalogo'
import useProductosTable from './useProductosTable'
import { useDescargablesContext } from '../../../context/DescargablesContext'
import useFetchDescargables from '../../../hooks/useFetchDescargables'


interface Props {
    productos: ProductosI
    home?: HomeI
    onDelete: () => void
}

const ProductosTable: FC<Props> = ({ productos, home, onDelete }) => {

    const { columns } = useProductosTable({ onDelete })

    const { descargables } = useDescargablesContext()
    useFetchDescargables()

    const mergeProductosDescargables = () => {

        return productos.map(producto => {
            const descargable = descargables.find(descargable => descargable.id === producto.idDescargable)
            return {
                ...producto,
                descargable: descargable?.titulo
            }
        })
    }




    return (
        <>
            <div style={{ height: 400, width: '100%' }}>
                <DataGrid
                    rows={mergeProductosDescargables()}
                    columns={columns}
                    pagination
                    // pageSizeOptions={[5]}
                    style={{ background: '#fff' }}
                />
            </div>

            { home && <Catalogo home={home} /> }

        </>

    )
}

export default ProductosTable